import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { AlertDataRequiredInputs } from "../components/AlertDataRequiredInputs";
import { AlertCardDataRequired } from "../components/AlertCardDataRequired";
import { AlertCardSucessProcess } from "../components/AlertCardSucessProcess";
import { AlertUserSessionExpiredToken } from "../components/AlertUserSessionExpiredToken";
import { useGroup } from "../context/groupContext";

function JoinGroupComponent() {
	const { joinGroup, loadingJoinGroup } = useGroup();

	const errorMessages = {
		accessCodeRequired: "Debe ingresar el codigo de acceso.",
		accessCodeInvalidLength:
			"El codigo de acceso no debe superar los 10 caracteres.",
	};

	const [apiResponse, setApiResponse] = useState(null);
	const {
		register,
		formState: { errors },
		handleSubmit,
		setValue,
	} = useForm();

	const accessCodeRegister = register("accessCode", {
		required: true,
		maxLength: 10,
	});

	const onSubmit = (data) => {
		joinGroup(data).then((res) => {
			setApiResponse(res);
		});
	};

	const handleAccessCodeChange = (event) => {
		accessCodeRegister.onChange(event);
		setValue("accessCode", event.target.value.toUpperCase(), {
			shouldValidate: true,
		});
	};

	return (
		<React.Fragment>
			<AlertUserSessionExpiredToken />
			<div className='container join-group-page'>
				<div className='join-group-shell'>
					<section className='join-group-intro card border-0'>
						<div className='card-body'>
							<p className='groups-page-eyebrow text-primary mb-2'>Acceso rapido</p>
							<h1 className='join-group-title mb-3'>
								Unete a un grupo con un codigo
							</h1>
							<p className='join-group-copy mb-0'>
								Si alguien te compartio un codigo de invitacion, ingresalo aqui y
								entra directo al grupo para empezar a pronosticar.
							</p>
						</div>
					</section>

					<form
						onSubmit={handleSubmit(onSubmit)}
						className='join-group-card card border-0'
					>
						<div className='card-body'>
							<label htmlFor='accessCode' className='form-label join-group-label'>
								Codigo de acceso
							</label>
							<input
								type='text'
								maxLength={10}
								className='form-control join-group-input'
								id='accessCode'
								placeholder='Ej. ABC123'
								{...accessCodeRegister}
								onChange={handleAccessCodeChange}
							/>
							<div className='join-group-helper mt-2'>
								Pidele al administrador el codigo exacto del grupo.
							</div>

							{errors.accessCode?.type === "required" && (
								<AlertDataRequiredInputs>
									{errorMessages.accessCodeRequired}
								</AlertDataRequiredInputs>
							)}
							{errors.accessCode?.type === "maxLength" && (
								<AlertDataRequiredInputs>
									{errorMessages.accessCodeInvalidLength}
								</AlertDataRequiredInputs>
							)}

							<button
								className='btn btn-primary btn-create_account join-group-submit'
								type='submit'
								disabled={loadingJoinGroup}
							>
								{loadingJoinGroup && (
									<span
										className='spinner-border spinner-border-sm'
										role='status'
										aria-hidden='true'
									></span>
								)}
								{loadingJoinGroup ? "Uniendo..." : "Unirme al grupo"}
							</button>

							{apiResponse &&
								(apiResponse?.IsSuccess ? (
									<AlertCardSucessProcess>
										Se ha unido correctamente al grupo.
									</AlertCardSucessProcess>
								) : (
									<AlertCardDataRequired>
										{apiResponse?.Errors[0]}
									</AlertCardDataRequired>
								))}

							<div className='join-group-tips'>
								<div className='join-group-tip'>
									<span className='join-group-tip-number'>1</span>
									<span>Ingresa el codigo tal como te lo compartieron.</span>
								</div>
								<div className='join-group-tip'>
									<span className='join-group-tip-number'>2</span>
									<span>Al entrar podras ver la tabla y cargar tus picks.</span>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</React.Fragment>
	);
}

export { JoinGroupComponent };
